import React, { useState } from 'react';
import { getClientes } from '../api';

export default function MovimentacaoModal({ produto, tipo, onConfirm, onCancel }) {
  const [quantidade, setQuantidade] = useState(1);
  const [clienteId, setClienteId] = useState('');
  const [clientes, setClientes] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const isEntrada = tipo === 'entrada';
  const maxQtd = isEntrada ? 9999 : produto.quantidade;

  if (!loaded && !isEntrada) {
    setLoaded(true);
    getClientes().then(setClientes).catch(() => {});
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (quantidade <= 0) return;
    if (!isEntrada && quantidade > produto.quantidade) return;
    const payload = { produto_id: produto.id, quantidade: Number(quantidade) };
    if (!isEntrada && clienteId) payload.cliente_id = Number(clienteId);
    onConfirm(payload);
  };

  return (
    <div className="ov" onClick={onCancel}>
      <div className="mo" onClick={(e) => e.stopPropagation()}>
        <h3>{isEntrada ? 'Adicionar Estoque' : 'Registrar Venda'}</h3>
        <div className="mo-sub">
          <strong>{produto.nome}</strong> — Estoque: {produto.quantidade} un.
          {!isEntrada && <><br/>Preço: R$ {Number(produto.preco).toFixed(2)}</>}
        </div>
        <form onSubmit={handleSubmit} className="fm">
          <span className="lbl">Quantidade</span>
          <div className="inp-r">
            <button type="button" className="btn btn3 btn-ico" disabled={quantidade <= 1} onClick={() => setQuantidade(Math.max(1, quantidade - 1))}>−</button>
            <input
              className="inp" type="number" min={1} max={maxQtd} value={quantidade}
              onChange={(e) => {
                const v = Number(e.target.value);
                if (isNaN(v) || v < 1) setQuantidade(1);
                else if (v > maxQtd) setQuantidade(maxQtd);
                else setQuantidade(v);
              }}
              style={{ textAlign: 'center', fontSize: 18, fontWeight: 700 }}
            />
            <button type="button" className="btn btn3 btn-ico" disabled={quantidade >= maxQtd} onClick={() => setQuantidade(Math.min(quantidade + 1, maxQtd))}>+</button>
          </div>
          {!isEntrada && clientes.length > 0 && (
            <select className="inp inp-sel" value={clienteId} onChange={(e) => setClienteId(e.target.value)}>
              <option value="">Sem cliente</option>
              {clientes.map(c => <option key={c.id} value={c.id}>{c.nome} ({c.total_pedidos} ped.)</option>)}
            </select>
          )}
          <div className="btn-g" style={{ justifyContent: 'flex-end', marginTop: 6 }}>
            <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
            <button className={`btn ${isEntrada ? 'btn1' : 'btn2'}`} type="submit">
              {isEntrada ? 'Adicionar Estoque' : 'Confirmar Venda'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
